import { escapeHtml } from '@wix/wix-chatbot-common/browser';

import { hasContent, isNumber } from '../../../util/guards';
import { IFieldState } from './types';

export const createState = (i: Partial<IFieldState>): Readonly<IFieldState> => ({
  maxLength: isNumber(i.maxLength) ? i.maxLength : -1,
  disabled: Boolean(i.disabled),
  hidden: Boolean(i.hidden),
  placeholder: i.placeholder,
  value: hasContent(i.value) ? escapeHtml(i.value) : '',
  attachFile: Boolean(i.attachFile),
  multiline: Boolean(i.multiline),
  nodeId: i.nodeId,
  change: Boolean(i.change),
});
